import { RegistrationSecurityIcon } from '@acorns/grove/icons'
import { useRemoteStrings } from '@acorns/web-utils'
import React from 'react'

import { Container, Text } from './styled-components'

export function SecurityFootnote() {
  const { getRemoteString } = useRemoteStrings()

  return (
    <Container>
      <RegistrationSecurityIcon />
      <Text>{getRemoteString({ key: 'registration.security_encryption_note' })}</Text>
    </Container>
  )
}
